module.exports = __webpack_public_path__ + "static/media/hall-P3.01ead410.svg";